import React, { useCallback, useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { useTranslation } from "react-i18next";
import axios, { AxiosError, AxiosResponse } from "axios";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import api from "../../../services/api";
import { IActionModalProps } from "..";
import { useToast } from "../../../hooks/toast";

const { confirm } = Modal;

interface IPorposal {
  project_id?: string;
}

const SendProposalModal: React.FC<IActionModalProps> = ({
  project,
  handleUpdateProject,
}) => {
  const { t } = useTranslation(["project-actions"]);
  const [loading, setLoading] = useState<boolean>(false);
  const [update, setUpdate] = useState<boolean | undefined>(
    false
  ); /*
  const [proposal, setProposal] = useState<IPorposal>(); */

  const { addToast } = useToast();

  const generateErrorToast = useCallback(
    (response: AxiosResponse | undefined) => {
      let description;
      let title = "Erro ao estimar";

      switch (response?.status) {
        case 405:
          description =
            "O projeto tem que estar na fase de envio da proposta para ser estimado";
          break;
        case 404:
          description = "O projeto não foi encontrado";
          break;
        case 401:
          title = "Error de Proposta";
          description = "O proposta não foi encontrado";
          break;
        default:
          description =
            "Um erro occoreu ao confirmar o envio da proposta, tente novamente";
      }

      addToast({
        type: "error",
        title,
        description,
      });
    },
    [addToast]
  );

  /* async function getProposal() {
    try {
      const resp = await api.get(`/proposal/generate/${project.id}`);
      setProposal(resp.data);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const serverError = err as AxiosError;
        generateErrorToast(serverError.response);
      } else {
        console.log(err);
      }
    }
  } */

  /*  useEffect(() => {
    getProposal();
  }, [confirm, update]); */

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    const payload = {};
    try {
      const response = await api.patch(
        `/projects/${project.id}/send-proposal`,
        payload
      );

      handleUpdateProject(response.data);

      addToast({
        type: "success",
        title: "Envio da proposta confirmado",
        description:
          "O envio da proposta foi confirmado e o projeto entrou na fase de aguardo da aprovação",
      });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const serverError = err as AxiosError;
        generateErrorToast(serverError.response);
      } else {
        console.log(err);
      }
    }

    setLoading(false);
  }, [addToast, generateErrorToast, handleUpdateProject, project.id]);

  const showConfirm = (): void => {
    setUpdate((old) => !old);
    confirm({
      title: "A proposta foi enviada para o cliente ?",
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          <p>
            Se confirmar, o projeto irá passar na fase &ldquo;Aguardando
            aprovação&ldquo;
          </p>
          {/* <p>
            {!proposal?.project_id ? "Você não gerou a proposta ainda" : ""}
          </p> */}
        </>
      ),
      onOk() {
        handleSubmit();
      },
      okButtonProps: {
        loading,
      },
    });
  };

  return (
    <Button type="primary" onClick={showConfirm}>
      Confirmar envio da proposta
    </Button>
  );
};

export default SendProposalModal;
